import { Show } from "solid-js";
import { useCheckoutFlowNavigation } from "@/hooks/checkoutFlowNavigation";
import { useCheckoutFlow } from "@/contexts/checkout-flow/checkout-flow.provider";

export const CheckoutFooter = () => {
  const { config, disablePrimaryButton, primaryButtonText } =
    useCheckoutFlowNavigation();
  const { isSubmitting } = useCheckoutFlow();

  return (
    <fd-mfe-container class="flex justify-between items-center p-FsSizing2x shadow-FsElevationSurface01 w-full sticky bottom-0 mt-FsSizing3x">
      <fd-mfe-button
        prop:rank="secondary"
        onClick={() => config().backAction()}
        prop:disabled={isSubmitting()}
      >
        {config().backText}
      </fd-mfe-button>
      <Show when={config().showPrimaryButton !== false}>
        <fd-mfe-button
          onClick={() => config().primaryAction()}
          prop:disabled={disablePrimaryButton()}
          data-testid="checkout-primary-button"
        >
          {primaryButtonText()}
        </fd-mfe-button>
      </Show>
    </fd-mfe-container>
  );
};
